import { render, staticRenderFns } from "./TabelaImportarProdutos.vue?vue&type=template&id=3b501d40&scoped=true"
import script from "./TabelaImportarProdutos.vue?vue&type=script&lang=js"
export * from "./TabelaImportarProdutos.vue?vue&type=script&lang=js"
import style0 from "./TabelaImportarProdutos.vue?vue&type=style&index=0&id=3b501d40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b501d40",
  null
  
)

export default component.exports